import React from "react";
import ReactMarkdown from "react-markdown";
import { markdownComponents } from "./Discuss.utils";

interface WelcomeMessageProps {
  message: string;
}

export const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ message }) => (
  <div className="px-4 py-3 rounded-lg text-sm bg-neutral-700 text-neutral-200">
    <div className="flex-1 prose prose-sm prose-li:marker:text-neutral-200 max-w-none">
      <ReactMarkdown components={markdownComponents}>{message}</ReactMarkdown>
    </div>
  </div>
);
